import { Checkbox } from 'antd'

import { createFormModal, updateFormModal, deleteConfirmationModal } from './Form'

const dateCell = ({ value }) => value || '-'

export const buildRewardProgramsPageLayout = ({ canUpdate, onToggleActive }) => ({
  content: {
    type: 'div',
    children: [
      {
        type: 'div',
        className: 'row',
        children: [
          { //section: page title
            type: 'div',
            className: 'col-12',
            children: [
              {
                type: 'page-title',
                heading: '{{REWARD_PROGRAMS}}',
                path: [
                  {
                    text: '{{WALLETS}}',
                    disabled: true
                  },
                  {
                    text: '{{REWARD_PROGRAMS}}',
                    disabled: true
                  }
                ]
              }
            ]
          },
          { //content
            type: 'div',
            className: 'col-12',
            children: [
              {
                type: 'card',
                children: [
                  {
                    //section: card action buttons
                    type: 'div',
                    className: 'd-flex justify-content-end align-items-center w-100 mb-4',
                    children: [
                      {
                        type: 'button',
                        isHide: 'noCreatePermission',
                        buttonType: 'text',
                        className: 'custom-color',
                        style: { backgroundColor: '$quaternary', color: '#ffffff' },
                        actionKey: 'OPEN_CREATE_MODAL',
                        size: 'large',
                        children: [
                          {
                            type: 'icon',
                            antIcon: 'PlusOutlined',
                            style: { color: '#fff', marginRight: '6px' },
                          },
                          {
                            type: 'text',
                            content: '{{CREATE}} {{REWARD_PROGRAM}}',
                          },
                        ],
                      }
                    ]
                  },
                  { //component: table
                    type: 'table',
                    dataKey: 'rewardPrograms',
                    updateTableInfo: 'UPDATE_TABLE_INFO',
                    metadataKey: 'tableMetadata',
                    columnFilterChangedKey: 'COLUMN_FILTER_CHANGED',
                    actionsContent: [
                      {
                        content: <i className="pe-7s-pen btn-icon-wrapper" />,
                        isHide: "noUpdatePermission",
                        actionID: 'UpdateRewardProgram',
                        color: 'primary',
                        tooltipContent: "{{EDIT}}",
                        actionKey: "OPEN_UPDATE_MODAL"
                      },
                      {
                        content: <i className="pe-7s-trash btn-icon-wrapper" />,
                        isHide: "noDeletePermission",
                        actionID: 'DeleteRewardProgram',
                        color: 'danger',
                        tooltipContent: "{{DELETE}}",
                        actionKey: "OPEN_DELETE_CONFIRMATION"
                      }
                    ],
                    columnsContent: [
                      {
                        Header: '{{REWARD_TYPE_ID}}',
                        accessor: 'reward_type_ids',
                        disableFilters: true,
                        Cell: ({ value }) => ( value || [] ).join( ', ' )
                      },
                      {
                        Header: '{{PROGRAM_KEY}}',
                        accessor: 'id'
                      },
                      {
                        Header: '{{NAME}}',
                        accessor: 'name'
                      },
                      {
                        Header: '{{DESCRIPTION}}',
                        accessor: 'description'
                      },
                      {
                        Header: '{{PROCESSING_FREQUENCY}}',
                        accessor: 'processing_frequency'
                      },
                      {
                        Header: '{{START_DATE}}',
                        accessor: 'start_date',
                        disableFilters: true,
                        Cell: dateCell
                      },
                      {
                        Header: '{{END_DATE}}',
                        accessor: 'end_date',
                        disableFilters: true,
                        Cell: dateCell
                      },
                      {
                        Header: '{{ACTIVE}}',
                        accessor: 'active',
                        disableFilters: true,
                        Cell: ({ row }) => (
                          <Checkbox
                            checked={ row.original.active }
                            disabled={ !canUpdate }
                            onChange={ e => onToggleActive( row.original, e.target.checked ) }
                          />
                        )
                      }
                    ]
                  }
                ]
              }
            ]
          },
          createFormModal,
          updateFormModal,
          deleteConfirmationModal
        ]
      }
    ]
  }
})
